<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="1" rx="0" ry="0" width="345" height="33" />
        <rect x="16" y="50" rx="0" ry="0" width="57" height="57" />
        <rect x="110" y="50" rx="0" ry="0" width="57" height="57" />
        <rect x="207" y="50" rx="0" ry="0" width="57" height="57" />
        <rect x="300" y="50" rx="0" ry="0" width="57" height="57" />
        <rect x="15" y="135" rx="0" ry="0" width="345" height="90" />
        <rect x="14" y="260" rx="0" ry="0" width="122" height="81" />
        <rect x="153" y="291" rx="0" ry="0" width="83" height="16" />
        <rect x="153" y="262" rx="0" ry="0" width="200" height="16" />
        <rect x="153" y="328" rx="0" ry="0" width="83" height="11" />
        <rect x="13" y="365" rx="0" ry="0" width="122" height="81" />
        <rect x="152" y="396" rx="0" ry="0" width="83" height="16" />
        <rect x="152" y="367" rx="0" ry="0" width="200" height="16" />
        <rect x="152" y="433" rx="0" ry="0" width="83" height="11" />
        <rect x="14" y="468" rx="0" ry="0" width="122" height="81" />
        <rect x="153" y="499" rx="0" ry="0" width="83" height="16" />
        <rect x="153" y="470" rx="0" ry="0" width="200" height="16" />
        <rect x="153" y="536" rx="0" ry="0" width="83" height="11" />
        <rect x="16" y="572" rx="0" ry="0" width="122" height="81" />
        <rect x="155" y="603" rx="0" ry="0" width="83" height="16" />
        <rect x="155" y="574" rx="0" ry="0" width="200" height="16" />
        <rect x="155" y="640" rx="0" ry="0" width="83" height="11" />
    </content-loader>
</template>

<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>


// WEBPACK FOOTER //
// src/skeleton/homeSkeleton.vue